import type { TimeseriesDto } from '@planuze/admin-contracts';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { useMetricsWidgetsContent } from '../../content/sections/metrics-widgets.js';
import { fmtCompactNumber, fmtDate, fmtDateShort, fmtNumber } from '../../lib/format.js';
import { ChartCard } from './chart-card.js';
import { colorAt } from './chart-palette.js';

interface Props {
  readonly data: TimeseriesDto | undefined;
  readonly loading: boolean;
}

/* Série de signups no tempo (line). MRR/churn timeseries são follow-up — só `signups`
   existe no backend (ADR-0353 §5). */
export function SignupsTimeseriesChart({ data, loading }: Props) {
  const points = data?.points ?? [];
  const copy = useMetricsWidgetsContent().signupsTimeseriesChart;
  return (
    <ChartCard title={copy.title} loading={loading} empty={points.length === 0}>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={points} margin={{ top: 8, right: 16, bottom: 0, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
          <XAxis dataKey="t" tickFormatter={fmtDateShort} fontSize={12} />
          <YAxis tickFormatter={fmtCompactNumber} fontSize={12} allowDecimals={false} />
          <Tooltip
            formatter={(value: unknown) => [fmtNumber(Number(value)), copy.tooltipSignups]}
            labelFormatter={(label: unknown) => fmtDate(String(label))}
          />
          <Line type="monotone" dataKey="v" stroke={colorAt(0)} strokeWidth={2} dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
